if ( typeof ImageHotspots !== 'function' ) {

  class ImageHotspots extends HTMLElement {

    constructor(){
			
      super();

      this._prefix = window.KT_PREFIX || '';

      this.daysEl = this.querySelector('.days');
      this.zIndex = 9;
      
      this.hotspots = this.querySelectorAll(
        `.${this._prefix}image-hotspots__spot--bullet`
      );
      let previoushotspot = null;

      // Check if hotspots should always be open
      const alwaysOpen = this.hasAttribute('data-always-open');

      if (alwaysOpen) {
        // Make all hotspots active by default
        this.hotspots.forEach((hotspot) => {
          hotspot.classList.add("active");
        });
      } else {
        // Original click behavior
        this.hotspots.forEach((hotspot) => {
          hotspot.addEventListener("click", (event) => {
            if (previoushotspot && previoushotspot !== event.target) {
              previoushotspot.classList.remove("active");
            }
            event.target.classList.toggle("active");
            event.target.parentNode.style.zIndex = this.zIndex++;
            previoushotspot = event.target;
            event.stopPropagation();
          });
        });

        document.addEventListener("click", (event) => {
          this.hotspots.forEach((hotspot) => {
            hotspot.classList.remove("active");
          });
          previoushotspot = null;
        });
      }

    }

  }

  if ( typeof customElements.get('image-hotspots') == 'undefined' ) {
    customElements.define('image-hotspots', ImageHotspots);
  }

}

if ( Shopify.designMode ) {
  document.addEventListener("shopify:block:select", (e) => {
    const block = e.target;
    const prefix = window.KT_PREFIX || '';
    if ( block.classList.contains(`${prefix}image-hotspots__spot`) ) {
      const bulletElements = document.querySelectorAll(
        ".image-hotspots__spot--bullet"
      );
      bulletElements.forEach((bulletElement) => {
        bulletElement.classList.remove("active");
      });
      const activeBullet = block.querySelector(`${prefix}image-hotspots__spot--bullet`);
      if (activeBullet) {
        activeBullet.classList.add('active');
      }
    }
  })
}